import { render, staticRenderFns } from "./nice-range-legend-item.vue?vue&type=template&id=651bcad6&scoped=true"
import script from "./nice-range-legend-item.vue?vue&type=script&lang=js"
export * from "./nice-range-legend-item.vue?vue&type=script&lang=js"
import style0 from "./nice-range-legend-item.vue?vue&type=style&index=0&id=651bcad6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651bcad6",
  null
  
)

export default component.exports